import React, { Component } from "react";
import { Table, Input, Button } from "antd";
import { httpGet, httpUrl, httpPut } from "../../api/httpClient";
import CategoryModal from "../../components/payment/CategoryModal";
import { showAlert } from "../../components/common/AlertModal";

const Search = Input.Search;

class Category extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      pagination: {
        current: 1,
        total: 0
      },
      searchText: "",

      type: false,
      visible: false,
      detailData: {}
    };
  }

  onSearch = (value) => {
    this.setState(
      {
        searchText: value
      },
      () => {
        this.getCategoryList();
      }
    );
  };

  onDelete = (row) => {
    if (global.confirm("카테고리를 삭제하시겠습니까?"))
      httpPut(httpUrl.categoryDelete, [row.idx], {})
        .then((res) => {
          showAlert("delete");
          this.getCategoryList();
        })
        .catch((e) => {});
  };

  getCategoryList = (params = {}) => {
    httpGet(httpUrl.getCategoryList, [0, this.state.searchText], {})
      .then((res) => {
        this.setState({
          list: res.data.list,
          total: res.data.total
        });
      })
      .catch((e) => {});
  };

  componentDidMount() {
    this.getCategoryList();
  }

  render() {
    const { list, visible, type, detailData, total } = this.state;

    const columns = [
      {
        title: "카테고리",
        dataIndex: "name",
        key: "name",
        className: "support-column-number fs-15 lh-21"
      },
      {
        title: "색상",
        dataIndex: "color",
        key: "color",
        className: "support-column-number fs-15 lh-21"
      },
      {
        title: "랭크",
        dataIndex: "rank",
        key: "rank",
        className: "support-column-number fs-15 lh-21"
      },
      {
        title: "",
        dataIndex: "under",
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => (
          <div>
            <Button
              onClick={() => {
                this.setState({ visible: true, type: true, detailData: row });
              }}>
              수정
            </Button>
            <Button
              className="m-l-10"
              onClick={() => {
                this.onDelete(row);
              }}>
              삭제
            </Button>
          </div>
        )
      }
    ];

    return (
      <div>
        {visible && (
          <CategoryModal
            type={type}
            visible={visible}
            detail={detailData}
            total={total}
            onCancel={() => {
              this.setState({
                visible: false,
                detailData: {}
              });
            }}
            onOk={this.getCategoryList}
          />
        )}
        <div
          style={{
            fontSize: "20px",
            color: "#000",
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "bold"
          }}>
          카테고리 관리
        </div>
        <div className="flex-row flex-center flex-sb m-b-10">
          <Button
            onClick={() => {
              this.setState({ visible: true, type: false });
            }}>
            생성
          </Button>
          <Search
            placeholder="카테고리를 입력해주세요."
            enterButton="검색"
            allowClear
            onSearch={this.onSearch}
            style={{ width: 400 }}
          />
        </div>
        <Table
          id="member-log-table"
          rowKey={(record) => record.idx}
          columns={columns}
          dataSource={list}
          style={{ marginBottom: "10px" }}
          pagination={false}
        />
      </div>
    );
  }
}

export default Category;
